import { gql } from '@apollo/client'

export const UPDATE_DOCUMENT = gql`
  mutation UPDATE_DOCUMENT($document: UpdateDocumentRequestDtoInput!) {
    documents {
      update(document: $document) {
        id
        caseId
        name
        status
        uploaded
      }
    }
  }
`
export interface UpdateDocumentVariables {
  document: {
    id: number
    name: string
  }
}

export interface UpdateDocumentResponse {
  documents: {
    update: {
      id: number
      caseId: number
      name: string
      status: string
      uploaded: string
    }
  }
}

export const DOCUMENT_UPLOAD = gql`
  mutation DOCUMENT_UPLOAD(
    $file: Upload!
    $fileMetadata: FileMetadataDtoInput!
  ) {
    documents {
      uploadFile(file: $file, fileMetadata: $fileMetadata) {
        success
        uploadedDocument {
          id
          name
          status
          uploaded
        }
      }
    }
  }
`

export interface DocumentUploadResponse {
  documents: {
    uploadFile: {
      success: boolean
      uploadedDocument: {
        id: number
        name: string
        status: string
        uploaded: string
      }
    }
  }
}

export interface DocumentUploadVariables {
  file: File | null
  fileMetadata: FileMetadataDtoInput
}

export interface FileMetadataDtoInput {
  caseId: number
  categoryId: number | null
  documentType: string
  replacedDocumentId?: number | null
  businessObjectId: number | null
  businessObjectType: string
}

export const SET_OPENED_DOC = gql`
  mutation SET_OPENED_DOC($documentId: Int!) {
    documents {
      setOpened(documentId: $documentId) {
        success
      }
    }
  }
`

export interface SetOpenedDocVariables {
  documentId: number
}

export interface SetOpenedDocResponse {
  success: boolean
}

export const IDP_PROCESS_DOCUMENTS = gql`
  mutation IDP_PROCESS_DOCUMENTS($request: IdpProcessDocumentRequestDtoInput!) {
    documents {
      idpProcessDocuments(request: $request) {
        success
        errorMessage
      }
    }
  }
`

export interface IdpProcessDocumentsVariables {
  request: {
    caseId: number
    uploadedDocumentIdList: number[]
    replaceMatterClientPortalDocumentId: number | null
    replaceMatterDocumentCheckListItemId: number | null
  }
}

export interface IdpProcessDocumentsResponse {
  documents: {
    idpProcessDocuments: {
      success: boolean
      errorMessage: string | null
    }
  }
}
